import { render, staticRenderFns } from "./u-sitemap-basic.vue?vue&type=template&id=90933f8e&scoped=true&"
import script from "./u-sitemap-basic.vue?vue&type=script&lang=js&"
export * from "./u-sitemap-basic.vue?vue&type=script&lang=js&"
import style0 from "./u-sitemap-basic.vue?vue&type=style&index=0&id=90933f8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90933f8e",
  null
  
)

export default component.exports